/**
 * What the festival list's two selects choose, and what each asks the server for. The status select's default is no
 * `status` at all: Tina's own "needs a person" set, so the list never holds a copy of it that could drift.
 */
import { FESTIVAL_STATUS_LABEL } from "@/lib/tina/festival-page";
import { FESTIVAL_KIND_LABEL } from "@/lib/tina/festivals";
import {
  FESTIVAL_STATUSES,
  type FestivalStatus,
} from "@/types/tina-festival-page";

/** One option of the status select: the server's default set, every status, or one of the nine. */
export type StatusChoice = "needs_a_person" | "every" | FestivalStatus;

/** The options in the order the select shows them; the labels are the nine of Plan 7 and the two extra choices. */
export const STATUS_CHOICE_LABEL: Record<StatusChoice, string> = {
  needs_a_person: "Needs a person",
  ...FESTIVAL_STATUS_LABEL,
  every: "Every status",
};

export const isStatusChoice = (value: unknown): value is StatusChoice =>
  typeof value === "string" && Object.hasOwn(STATUS_CHOICE_LABEL, value);

/** The `status` the request carries; `undefined` is "the server's default set". */
export function statusFilterValue(
  choice: StatusChoice,
): FestivalStatus[] | undefined {
  if (choice === "needs_a_person") return undefined;
  if (choice === "every") return [...FESTIVAL_STATUSES];
  return [choice];
}

/** One option of the type select (no choice at all is "All types"). */
export type TypeChoice = "day_ticket" | "program" | "unclear";

export const TYPE_CHOICE_LABEL: Record<TypeChoice, string> = {
  day_ticket: FESTIVAL_KIND_LABEL.day_ticket,
  program: FESTIVAL_KIND_LABEL.program,
  unclear: FESTIVAL_KIND_LABEL.unclear,
};

export const isTypeChoice = (value: unknown): value is TypeChoice =>
  typeof value === "string" && Object.hasOwn(TYPE_CHOICE_LABEL, value);
